export const disablePageScrollY = () => {
    document.body.style.overflowY = 'hidden';
};

export const enablePageScrollY = () => {
    document.body.style.overflowY = '';
};
